export default function InputNumberField(props){
    var step = props.step?props.step : 0
    async function controlledUpdate(element) {
        if (!!props.setState) {
            props.setState(element.target.value)
        }
    }

    return (
        <div className="input-wrapper text-input">
            <label htmlFor={props.name}>
                {props.labelText}: 
            </label>
            <input name={props.name} id={props.name} type="number" step={step} required={!!props.required}
                value={props.state} onChange={(el) => controlledUpdate(el)}
            />
        </div>
    )
}